const Background = ({ children, color }) => (
    <div className={color}>{children}</div>
  );
  
  export { Background };
  